export class A9DecoratorsCommon {
    public static parseConstructorParams(parsedClass: any): string[] {
        const fnStr: string = parsedClass.toString();
        const result = fnStr.match(/\(([^)]*)\)/);

        if (result) {
            return result[1]
                .replace(/\/\*[^*]+\*\//g, '')
                .split(',')
                .map((v: string) => v.trim())
                .filter((v: string) => !!v);
        }
        return [];
    }
}
